import React, {useEffect} from 'react';
import * as actions from '../actions';

export function FieldAppInspectionDetail() {
	return <div className='dashboard fieldApp'>
		<section className='expander expanded'>
			<div className='inner centered'>
				<h1>Inspecting <span>2. Install, 3. Post Install Glass Inserts</span></h1>
			</div>
		</section>
		<section className='expander expanded'>
			<header><button tabIndex={1}><span className='icon inspect'>KITCHEN <span className='subtitle'>0 of 21</span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className='inner'>
				<div className='inspectionItems'>
					<div className='inspectionItem yes'>
						<div className="radio">
							<button className="icon yes on"><span></span></button><button className="icon no"><span></span></button><button className="icon na"><span></span></button>
						</div>
						<div className='description'>
							<div className='property'>Overall Impression</div>
							<div className='value'></div>
						</div>
					</div>
					<div className='inspectionItem no'>
						<div className="radio">
							<button className="icon yes"><span></span></button><button className="icon no on"><span></span></button><button className="icon na"><span></span></button>
						</div>
						<div className='description'>
							<div className='property'>Plumb, Level &amp; Square</div>
							<div className='value'></div>
						</div>
					</div>
					<div className='inspectionItem na'>
						<div className="radio">
							<button className="icon yes"><span></span></button><button className="icon no"><span></span></button><button className="icon na on"><span></span></button>
						</div>
						<div className='description'>
							<div className='property'>Appliance Openings</div>
							<div className='value'></div>
						</div>
					</div>
					<div className='inspectionItem'>
						<div className="radio">
							<button className="icon yes"><span></span></button><button className="icon no"><span></span></button><button className="icon na"><span></span></button>
						</div>
						<div className='description'>
							<div className='property'>Manufacturer</div>
							<div className='value'>Kitchen Craft</div>
						</div>
					</div>
					<div className='inspectionItem'>
						<div className="radio">
							<button className="icon yes"><span></span></button><button className="icon no"><span></span></button><button className="icon na"><span></span></button>
						</div>
						<div className='description'>
							<div className='property'>Door Style</div>
							<div className='value'>Plymouth</div>
						</div>
					</div>
				</div>
				<footer className='inspectionActions'>
					<button className="icon iconLabel deficiency"><span>ADD DEFICIENCY</span></button>
					<button className="icon iconLabel note"><span>ADD NOTE</span></button>
					<button className="icon iconLabel "><span>MARK ALL N/A</span></button>
					<button className="icon iconLabel ok"><span>MARK ALL OK</span></button>
				</footer>
			</div>
		</section>
	</div>;
}